import RequestPageTwo from "./RequestPageTwo";

const SoloRetreatReg = () => {
    return (
        <RequestPageTwo title="Solo Retreat Regis"
            fetchUrl="/get-solo-retreats"
            editEndpoint="update-solo-retreats"
            deleteEndpoint="solo-retreats"
            statusEndpoint="solo-retreats" />
    );
}

export default SoloRetreatReg;
